import { axiosJwt } from '@/shared/auth/axiosJwt';

const apiBase = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CHECKOUT_PORT}${process.env.VUE_APP_API_PATH}/checkout`;

export default {
    obterProdutosCheckouts(filtro) {
        return axiosJwt.get(`${apiBase}/produtocheckout`, { params: filtro });
    },

    obterCheckoutId(checkoutId) {
        return axiosJwt.get(`${apiBase}/produtocheckout/produto_checkout/${checkoutId}`);
    },
    obterCompradores() {
        return axiosJwt.get(`${apiBase}/produtocheckout/produto_checkout/compradores`);
    },
    obterEventos() {
        return axiosJwt.get(`${apiBase}/produtocheckout/produtos`);
    },
    exportar() {
        return axiosJwt.get(`${apiBase}/produtocheckout/exportar`, { responseType: 'blob' });
    },
    exportarExcel() {
        return axiosJwt.get(`${apiBase}/produtocheckout/exportar_excel`, { responseType: 'blob' });
    },
    atualizarDataVencimento(checkoutId, dataVencimento) {
        return axiosJwt.post(`${apiBase}/produtocheckout/${checkoutId}/data_vencimento`, dataVencimento);
    },
    reenviarEmail(produtoCheckous) {
        return axiosJwt.post(`${apiBase}/produtocheckout/reenviar_email`, produtoCheckous);
    },
    inativarLinkPagamento(produtoCheckoutId) {
        return axiosJwt.post(`${apiBase}/produtocheckout/inativar/${produtoCheckoutId}`);
    },
    solicitarRelatorioConciliacao() {
        return axiosJwt.post(`${apiBase}/produtocheckout/solicitar-envio-relatorio`);
    },
    obterProjetos(id) {
        return axiosJwt.get(`${apiBase}/tabelas/projetos_por_unidade/${id}`);
    },
    obterAcoes(codProjeto, codUnidade) {
        return axiosJwt.get(`${apiBase}/tabelas/acoes?codProjeto=${codProjeto}&codUnidade=${codUnidade}`);
    },
    obterUnidadesOperacionais() {
        return axiosJwt.get(`${apiBase}/tabelas/unidadesOperacionais`);
    },
};
